import React, { useState, } from 'react';
import ReactImageCarousel, { Modal, ModalGateway, } from 'react-images';
import { Box, } from '@waglabs/box-next';
import { Button } from '@waglabs/button-next';
import { Flex } from '@waglabs/flex-next';
import { PlayIcon } from '@waglabs/icons';
import { LazyImage, } from '@waglabs/lazyload';
import { IFrameVideoLightboxView } from './components/IFrameVideoLightboxView';
export const VideoLightbox = ({ thumbnail, thumbnailSet, thumbnailProps, text = 'Watch the video', src, }) => {
    const [isVideoShowing, setIsVideoShowing] = useState(false);
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, { height: ['280px', '520px'], width: [1, null, '769px'], py: "16px", mx: "auto", backgroundRepeat: "no-repeat", style: {
                backgroundPositionX: '16px',
                backgroundPositionY: '30px',
            } },
            React.createElement(Box, { height: ['200px', '440px'], width: 1, borderRadius: "6px", overflow: "hidden" },
                React.createElement(LazyImage, Object.assign({ srcSet: thumbnailSet, src: thumbnail, width: [1, null, '769px'], height: ['200px', '440px'], imageProps: {
                        onClick: () => setIsVideoShowing(true),
                        width: '100%',
                        height: '100%',
                        style: {
                            objectFit: 'cover',
                        },
                    } }, thumbnailProps))),
            React.createElement(Flex, { pl: ['unset', '36px'] },
                React.createElement(Button, { mt: ['-36px', '-48px'], onClick: () => setIsVideoShowing(true), zIndex: 99 },
                    React.createElement(PlayIcon, { fontSize: ['48px', '96px'] })),
                React.createElement(Flex, { height: ['20px', '40px'], mx: ['unset', '16px'], mt: "8px", overflow: "hidden" },
                    React.createElement(Button, { fontFamily: "muliBold", fontSize: ['16px', '20px'], color: "wagGreen", m: 0, onClick: () => setIsVideoShowing(true) }, text)))),
        React.createElement(ModalGateway, null, isVideoShowing ? (React.createElement(Modal, { onClose: () => setIsVideoShowing(false) },
            React.createElement(ReactImageCarousel, { currentIndex: 0, components: {
                    Footer: null,
                    View: IFrameVideoLightboxView,
                }, frameProps: {
                    autoSize: 'height',
                }, views: [{
                        source: src,
                    }] }))) : null)));
};
